module.exports = __webpack_public_path__ + "img/bs1.952403c3.png";